<template>
  <div :id="content.key" class="special-module content_w_710" :class="device.isMobile ? 'special-module-mobile' : ''">
    <img :id="`${content.key}-1`" :src="content.top_img" />
    <div :id="`${content.key}-2`" class="special-module-content">
      <div class="content-back" :style="`background-image: url(${content.left_img});`"></div>
      <textIndex class="content" v-for="item in content.content" :key="item.key" :content="item" :isInTable="true"></textIndex>
    </div>
  </div>
</template>
<script>
/*
正文组件 特殊正文 -- 重点
*/
import textIndex from "./index.vue";

export default {
  name: "textIndexSpecial",
  components: {
    textIndex,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 30rem auto;
  user-select: text;
}

.special-module {
  margin-bottom: 30rem;

  img {
    display: block;
    width: 100%;
  }

  .special-module-content {
    width: 100%;
    padding: 15rem;
    padding-left: 150rem;
    font-family: "宋体";
    font-weight: bold;
    border: 1rem solid #00a8ac;
    box-shadow: 0 3rem 16rem 0 rgba(32, 37, 36, 0.1);
    background-color: rgba(255, 255, 255, 0.7);
    position: relative;

    .content-back{
      width: 128rem;
      height: 71rem;
      position: absolute;
      top: 50%;
      left: 7rem;
      margin-top: -35rem;
      background-repeat: no-repeat;
      background-position: center left;
      background-size: contain;
    }

    .content{
      font-size: 19rem;
      line-height: 36rem;
      color: #333;
      font-weight: bold;
    }
  }
}
.special-module-mobile{
  margin: 60rem auto;
  
  .special-module-content {
    .content{
      font-size: 20rem;
    }
  }
}
</style>